import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaVisualizar(inscricao) {
  inscricao.dataNascimento = formatarData.paraData(inscricao.dataNascimento);

  return inscricao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/solicitacaoCursoEventoMatricular', { params: parametros });
  },
  listaDeTurmas: async function () {
    return await Vue.http.get('/api/solicitacaoCursoEventoMatricular/turmas').then(response => response.data);
  },
  matricular: id => {
    return Vue.http.post(`/api/solicitacaoCursoEventoMatricular/${id}/matricular`)
      .then(response => response.data);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaoCursoEventoMatricular/${id}`)
      .then(response => response.data)
      .then(inscricao => normalizarParaVisualizar(inscricao));
  },
  alterarNotas: async (inscricao, id) => {
    inscricao = await converterObjetoFormData(inscricao);

    return Vue.http.put(`/api/solicitacaoCursoEventoMatricular/${id}/notas`, inscricao).then(res => res.data);
  },
  desmatricular: id => {
    return Vue.http.post(`/api/solicitacaoCursoEventoMatricular/${id}/desmatricular`)
      .then(response => response.data);
  },
  listagemExcel: filtros => {
    return Vue.http.get('/api/solicitacaoCursoEventoMatricular/Excel',
      {
        params: {
          idTurma: filtros.idTurma
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-curso-evento-matricular/servico.js